// The three membership tiers' CHF prices (whole units), keyed by tier — the
// site's single source, mirroring glue `price-guard`'s `NON_STRIPE_VALID_CHF`
// (AHD-11665). Dependency-free so any widget, page or server module can import
// it; no client-only or server-only imports may be added here.
export const MEMBERSHIP_TIER_PRICES_CHF = {
  "1x": 299,
  "2x": 499,
  "4x": 899,
} as const

export type MembershipTierId = keyof typeof MEMBERSHIP_TIER_PRICES_CHF
